import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/Header.css';
import Navbar from './Navbar';
import MobileHeader from './MobileHeader';

const Header = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const WealthHorizonLogo="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/WealthHorizon.svg";

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
      const currentScroll = window.pageYOffset;
      const scrollPercentage = (currentScroll / totalScroll) * 100;
      setScrollProgress(scrollPercentage);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
    };

    // Initial check
    handleResize();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Render mobile header for small screens
  if (isMobile) {
    return <MobileHeader />;
  }

  // Render desktop header for large screens
  return (
    <header className="header">
      <div className="scroll-progress">
        <div
          className="scroll-progress-bar"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>
      
      {/* Delicate floating elements */}
      <div className="particle-1" />
      <div className="particle-2" />
      <div className="particle-3" />
      <div className="particle-4" />
      <div className="particle-5" />
      <div className="particle-6" />
      
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={WealthHorizonLogo} alt="Wealth Horizon" style={{ marginLeft: '1rem' }} />
        </Link>

        <div className="navbar">
        <Navbar />
        </div>

        <div className="header-buttons">
          <a href="/contact-us" className="book-meeting">
            <span className="arrow-icon">↗</span>
            Get In Touch
          </a>
          <a href="https://app.maxiomwealth.com/login" target="_blank" rel="noopener noreferrer" className="login-btn">Login</a>
        </div>
      </div>
    </header>
  );
};

export default Header;